import jmoment from "jalali-moment";

export function toJalali(gregorianDate: string): string {
  if (!gregorianDate) return "";
  jmoment.locale("fa");
  return jmoment.from(gregorianDate, "en", "YYYY-MM-DD").format().split("T")[0]; // it would be in jalali system
}

export function toJalaliDateTime(date: string | number | Date): string {
  if (!date) return "";
  // jalali-moment's bare constructor (jmoment(date)) silently fails to parse ISO strings with
  // milliseconds+Z in this build -- it returns a "valid" moment stuck at midnight instead of throwing,
  // so this went unnoticed for a while. jmoment.from(str, locale, format) (the same primitive toJalali
  // above already relies on) parses correctly, but only against a matching format with no leftover
  // characters -- so parse with native Date first (always reliable) and feed its local-time components
  // through .from() instead of the raw ISO string.
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  const localDateTime = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  return jmoment
    .from(localDateTime, "en", "YYYY-MM-DD HH:mm:ss")
    .locale("fa")
    .format("jYYYY/jMM/jDD HH:mm:ss");
}

export function toGregorianDateTime(date: string | number | Date): string {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
